<template>
  <van-row class="check-item shadow">
    <van-col
      :offset="1"
      :span="hasRightValue ? 7 : 22"
      :class="hasRightValue && 'van-ellipsis'"
    >
      {{ item.projectCode || item.costCenterCode || item.svalue || item.name || item.cName || item.gzmc }}
    </van-col>
    <van-col
      :offset="1"
      :span="15"
    >
      {{ item.projectName || item.costCenterName || item.district || item.gzdm }}
      {{ item.ccsy }}
    </van-col>
  </van-row>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasRightValue() {
      let item = this.item
      return item.projectName || item.costCenterName || item.district || item.gzdm || item.ccsy
    }
  }
}
</script>

<style lang="less" scoped>
.check-item {
  padding: 15px 10px;
}
</style>